// The reads the checkout mutation resolves before it builds a request. Kept
// here, in one hook, rather than in the mutation itself: the mutation then
// takes two booleans instead of two store slices, and this file is the only
// thing standing between it and a headless body.
//
// Both reads are now Jotai atoms, so the hook imports neither `@/store` nor
// `react-redux` and carries no suppression.
import { hasIntegrationAtom } from '@/atoms/integrationAtoms';
import { widgetTokenAtom } from '@/atoms/integrationAuthAtoms';
import { useAtomValue } from 'jotai';

type CheckoutRequestContext = {
  /**
   * Widget launches hold an integration-auth token and check out through the
   * OpenAPI session endpoint instead of the scribe one.
   */
  useOpenApiCheckout: boolean;
  /** Integrations do NOT need a credit card when starting a trial. */
  ccRequired: boolean;
};

export function useCheckoutRequestContext(): CheckoutRequestContext {
  const widgetToken = useAtomValue(widgetTokenAtom);
  const hasIntegration = useAtomValue(hasIntegrationAtom);

  return {
    useOpenApiCheckout: !!widgetToken,
    ccRequired: !(hasIntegration || !!widgetToken),
  };
}
